import axios from 'axios'
import React, { useState, useEffect, useMemo, Fragment, useRef } from 'react'
import { FormControl, InputLabel, Input, FormHelperText, ButtonGroup, Menu } from '@mui/material'
import WebService from '@util/webService'
import { encodeParams, findCode, getAction, printVariable } from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux'
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField, withStyles, InputBase } from '@mui/material'
import { styled, alpha } from '@mui/material/styles'
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton'
import useSnackbar from '@hooks/useSnackbar'
import MyTableHead from '@components/MyTableHead'
import useIndicator from '@hooks/useIndicator'
import Indicator from '@components/Indicator'
import MyDialog from '@components/MyDialog'
import useForm from '@hooks/useForm'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
// pagination
import { useTheme } from '@mui/material/styles'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import LastPageIcon from '@mui/icons-material/LastPage'
import ControlPointIcon from '@mui/icons-material/ControlPoint'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import Paper from '@mui/material/Paper'
import moment from 'moment'
import { Avatar, Grid, Container } from '@mui/material/'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { isNewExpression, nullLiteral } from '@babel/types'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import { searchSchool } from '@util/helper'
import ManagerRegiPart from './manager-regi.part'
import ManagerRegiPartName from './manager-regi.part.name'
import ConfirmDialog from '@components/ConfirmDialog'
import ManagerRegiPartHistory from '@pages/manager/manager-regi.part.history'
import ManagerRegiPartPick from '@pages/manager/manager-regi.part.pick'
import ManagerRegiPartBill from '@pages/manager/manager-regi.part.bill'
import { useParams } from 'react-router-dom'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ManagerNoticePartMod from '@pages/manager/manager-notice.part.mod'
import ManagerRegiPartAgency from '@pages/manager/manager-regi.part.agency'
import useAlert from '@hooks/useAlert'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabContext from '@mui/lab/TabContext'
import TabPanel from '@mui/lab/TabPanel'
import Divider from '@mui/material/Divider'
import ManagerRegiPartUpload from './manager-regi.part.upload'
import ManagerRegiPartDownload from './manager-regi.part.download'
import { download } from '@util/helper'
import { useLocation } from 'react-router-dom'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import ManagerMessagePartPost from './manager-message.part.post'
import Tooltip from '@mui/material/Tooltip'
import Badge from '@mui/material/Badge'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import AlertOutlineIcon from '@mui/icons-material/ErrorOutline'
import PriorityHighIcon from '@mui/icons-material/PriorityHigh'
import QuestionMarkIcon from '@mui/icons-material/QuestionMark'
import InfoIcon from '@mui/icons-material/Info'
import TableSortLabel from '@mui/material/TableSortLabel'
import { transformData } from './manager-lecture.page'

/**
 -1 <= phase < 0 : 강좌 데이터 검증 전(특히 파일 업로드 한 경우)
 0 <= phase < 1 : 강좌 데이터 완료
 1 <= phase < 2 : 수강 신청 중
 2 <= phase < 3 : 모집 종료, 학생 선발 전
 3 <= phase < 4 : 학생 선발 후, 등록 중
 4 <= phase < 5 : 등록 마감 강좌 시작 전
 5 <= phase     : 개강준비 완료
 */
const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`
const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`
const RLTN_CODE = 'S003'
const weekOrder = { 월: 1, 화: 2, 수: 3, 목: 4, 금: 5, 토: 6, 일: 7 }
const ManagerRegiPage = () => {
  console.log('ManagerRegiPage rendering...')
  const g_sel_code = 'SA07'
  const g_stat_code = 'SA12'
  const g_week_code = 'SB07'
  const { more } = useParams()
  const inputRef = useRef()
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const [detailScreen, set_detailScreen] = useState(false)
  const [isNew, set_isNew] = useState(false)
  const [schoolList, set_schoolList] = useState([])
  const [teacherList, set_teacherList] = useState([])
  const [smstList, set_smstList] = useState([])
  const [lessonList, set_lessonList] = useState([])
  const [lectureList, set_lectureList] = useState([])
  const [selCodeList, set_selCodeList] = useState([])
  const [statCodeList, set_statCodeList] = useState([])
  const postHandler = useState(false)
  const location = useLocation()
  const curLocationRef = useRef(location)
  const [sortBy, set_sortBy] = useState(() => {
    // TODO,  솟팅 확인 필요
    return localStorage.getItem('lastSortBy') || 'title'
    // return 'title'
  })
  const [sortDirection, set_sortDirection] = useState('asc')
  const [counter, set_counter] = useState(0)
  const originRef = useRef({})

  const handleSort = (property) => {
    console.log('property=>', property)
    //  같은 컬럼을 또 클릭했으면 방향을 뒤집고, 새로운 컬럼이면 'asc'로 시작
    const isAsc = sortBy === property && sortDirection === 'asc'
    const direction = isAsc ? 'desc' : 'asc'

    set_sortBy(property)
    set_sortDirection(direction)
    // TODO,  솟팅 확인 필요
    localStorage.setItem('lastSortBy', property)
    set_counter((prev) => prev + 1)
  }
  
  
  const [dataList, set_dataList] = useState([])
  const [schoolGroup, set_schoolGroup] = useState([])
  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const { alert, renderAlert } = useAlert()
  const dgHandler = useState(false)
  const [selIdx, set_selIdx] = useState(-1)
  const [pageNum, set_pageNum] = useState(0)
  const [pageSize, set_pageSize] = useState(10)
  const [totalCount, set_totalCount] = useState(0)
  const [pageInfo, set_pageInfo] = useState({ pageNum: 0, pageSize: -1 })
  
  const [fontSize, set_fontSize] = useState(12)
  const [selStudentList, set_selStudentList] = useState([])
  
  const [schoolRowSpan, set_schoolRowSpan] = useState({})
  const [openName, set_openName] = useState(false)
  const [openHistory, set_openHistory] = useState(false)
  const [openPick, set_openPick] = useState(false)
  const [openBill, set_openBill] = useState(false)
  const [tabValue, set_tabValue] = useState('-1')
  const agencyHandler = useState(false)
  // redux
  const codeGroups = useSelector((state) => state.codeGroupReducer)
  const codes = useSelector((state) => state.codeReducer)
  const schools = useSelector((state) => state.schoolReducer)
  const account = useSelector((state) => state.accountReducer)
  const schola = useSelector((state) => state.scholaReducer)
  //
  const actionHandler = useState(false)
  const dgRef = useRef()
  const dgRef2 = useRef()
  

  const weekCodeList = useMemo(() => {
    const cs = codes.filter((c) => c.codeGroupId === g_week_code)
    cs.forEach((r) => {
      r.id = r.code
    })
    return cs
  }, [codes])
  
  const fields = [
    { field: 'smstName', placeholder: '년도/기수', type: 'text', value: '', visible: true, canSrch: false, selList: smstList },
    { field: 'id', placeholder: '강좌ID', type: 'text', value: -1, visible: more && more === 'more', canSrch: false, selList: [] },
    {
      field: 'title',
      placeholder: '강좌명',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
      sortable: true,
    },
    { field: 'weekCode', placeholder: '요일', type: 'checkbox', value: '', visible: false, canSrch: false, selList: weekCodeList },
    {
      field: 'weekString',
      placeholder: '요일',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
      sortable: true,
    },
    {
      field: 'rcrNum',
      placeholder: '모집',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
    },
    {
      field: 'reqNum',
      placeholder: '신청',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
    },
    {
      field: 'prcNum',
      placeholder: '진행',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
    },

    {
      field: 'sttNum',
      placeholder: '등록',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
    },
    {
      field: 'statName',
      placeholder: '상태',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
    },

    {
      field: 'phase',
      placeholder: '단계',
      type: 'text',
      value: '',
      visible: more && more === 'more',
      canSrch: false,
      disabled: false,
      selList: [],
    },
  ]
  // const [fields, set_fields] = useState([...defFields])
  const gdnFields = [
    { field: 'name', placeholder: '성명' },
    { field: 'loginId', placeholder: 'ID' },
    { field: 'phone', placeholder: '전화번호' },
    { field: 'phoneCertYn', placeholder: '인증여부' },
  ]
  const visibleColumns = fields.filter((col) => col.visible)
  const defRecord = {}
  fields.forEach((d) => {
    defRecord[d.field] = d.value
  })
  defRecord.schoolList = []
  const defTerms = {}
  fields
    .filter((col) => col.canSrch)
    .map((d) => d.field)
    .forEach((d) => (defTerms[d] = ''))
  const recordRef = useRef(defRecord)
  const [terms, _set_terms] = useState(defTerms)
  const termsRef = useRef(terms)
  const set_terms = (data) => {
    termsRef.current = data
    _set_terms(data)
  }
  const onLoadOld = async () => {
    // openIndicator()
    // const smstGroup = await fetchLecturesWithExtra()
    // Object.keys(smstGroup).forEach((key) => {
    //   const lectures = smstGroup[key]
    // })
    // originRef.current = smstGroup
    // set_counter(counter + 1)
    // closeIndicator()
  }

  const onLoad = async () => {
    openIndicator()
    originRef.current = await fetchLecturesWithExtra()
    closeIndicator()
    set_counter(counter + 1)
  }

  const onSaveEmptyPickList = async () => {
    const url = `/lecture/pick/${schola.id}/${recordRef.current.id}`

    const formData = new FormData()
    const data = {
      pickIdList: [],
      excIdList: [],
    }

    const jsonData = JSON.stringify(data)

    formData.append('body', new Blob([jsonData], { type: 'application/json' }))
    openIndicator()
    const resp = await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    closeIndicator()

    if (resp.data.repCode === 'ack') {
      alert('처리되었습니다.')
      onLoad()
    } else {
      alert(resp.data.repMessage)
    }
  }

  const fetchLectures = async () => {
    const url = `/regi/school/${schola.id}`
    const resp = await WebService.get(url)
    if (resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      records.forEach((row) => {
        row.statName = findCode(codes, 'SA08', row.statCode)?.name ?? ''
      })
      return records
    } else {
      openSnackbar(resp.repMessage)
    }
  }
  const fetchLecturesWithExtra = async () => {
    let url = `/lecture/extra/${schola.id}`
    const newTerms = {}
    let tempList
    let resp = await WebService.get(url, {
      pageNum: pageInfo.pageNum,
      pageSize: pageInfo.pageSize,
      terms: JSON.stringify(newTerms),
    })
    if (resp.repCode !== 'ack') {
      openSnackbar(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const originList = JSON.parse(repMessage.records)
    if (repMessage.totalCount) {
      const totalCount = repMessage.totalCount
      set_totalCount(totalCount)
    }
    const records = originList.reduce((acc, cur, idx, arr) => {
      const lecture = cur.lecture
      lecture.smstId = cur.smst.id
      lecture.year = cur.smst.year
      lecture.gisu = cur.smst.gisu
      lecture.smstPhase = cur.smst.phase
      lecture.teacherName = cur.teacher.name
      lecture.userId = cur.teacher.id
      lecture.statName = findCode(codes, 'SA08', lecture.statCode)?.name ?? ''
      lecture.overCode = cur.smst.overCode
      lecture.smstSelCode = cur.smst.selCode
      lecture.weekString = ''

      acc.push(lecture)
      return acc
    }, [])
    return records
    //

    // const smstGroup = records.reduce((acc, cur) => {
    //   const key = '' + cur.year + '/' + cur.gisu
    //   if (acc[key]) {
    //     acc[key].push(cur)
    //   } else {
    //     acc[key] = [cur]
    //   }
    //   cur.groupId = key
    //   return acc
    // }, {})
    // return smstGroup
  }

  const canDownload = (row) => {
    return row.phase >= 3 && row.statCode !== 'S004' && row.rcrNum < row.reqNum
  }

  const handleDownload = async (row) => {
    if (row.selCode == 'S002') {
      alert('선착순의 경우에는 동영상을 저장하지 않습니다.')
      return
    }
    const serverUrl = encodeURI(`/lecture/download/webm/${row.id}`)
    const response = await axios.get(serverUrl, {
      responseType: 'blob', // Set responseType to 'blob' for binary data
    })
    if (!response) {
      alert('파일이 존재하지 않습니다.')
    }

    //
    const contentDispositionHeader = response.headers['content-disposition']
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    const matches = filenameRegex.exec(contentDispositionHeader)
    let suggestedFilename = 'downloaded_file' // Default filename if not found

    if (matches != null && matches[1]) {
      suggestedFilename = decodeURIComponent(matches[1]).replace(/['"]/g, '') // Remove quotes if present
    }

    // Create a Blob object from the response data
    const blob = new Blob([response.data], { type: response.headers['content-type'] })

    // Create a temporary URL for the Blob
    const url = window.URL.createObjectURL(blob)

    // Create a link element to trigger the download
    const link = document.createElement('a')
    link.href = url
    link.download = suggestedFilename
    document.body.appendChild(link)

    // Trigger the download
    link.click()

    // Clean up the temporary URL and link
    window.URL.revokeObjectURL(url)
    document.body.removeChild(link)
  }

  const handleSampleDownload = async (row) => {
    const url = `/regi/download/tmpl`
    await download(url)
  }

  const onDetail = async (id) => {
    set_detailScreen(true)
    dgHandler[1](true)
  }
  const onDiscard = async (lectureId) => {
    openIndicator()
    const url = `/lecture/discard/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('처리 되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }
  const onStartReq = async (lectureId) => {
    openIndicator()
    const url = `/lecture/req/start/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('처리 되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }
  const onQuitReq = async (lectureId) => {
    openIndicator()
    const url = `/lecture/req/quit/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('처리 되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onReopen = async (lectureId) => {
    const url = `/lecture/reopen/${schola.id}/${lectureId}`
    openIndicator()
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('처리 되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onPauseReq = async (lectureId) => {
    openIndicator()
    const url = `/lecture/req/pause/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('처리 되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onAttdnc = async (lectureId) => {
    openIndicator()
    const url = `/attdnc/lecture/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      openSnackbar('출석부를 생성하였습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onOpenLecture = async (lectureId) => {
    openIndicator()
    const url = `/lecture/open/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('개강상태로 변경되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onCloseLecture = async (lectureId) => {
    openIndicator()
    const url = `/lecture/close/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('종강상태로 변경되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onResetLecture = async (lectureId) => {
    openIndicator()
    const url = `/lecture/reset/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('리셋되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onRecover = async (lectureId) => {
    const url = `/lecture/recover/${schola.id}/${lectureId}`
    openIndicator()
    const resp = await WebService.post(url)
    closeIndicator()
    if (resp.repCode === 'ack') {
      alert('이전 상태로 복구 되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
  }
  const handleChangePage = (event, newPage) => {
    set_pageInfo({ ...pageInfo, pageNum: newPage })
  }
  const handleChangeRowsPerPage = (event) => {
    const pageSize = parseInt(event.target.value, 10)
    set_pageInfo({ pageNum: 0, pageSize: pageSize })
  }
  const TablePaginationActions = (props) => {
    const theme = useTheme()
    const { count, page, rowsPerPage, onPageChange } = props
    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0)
    }
    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1)
    }
    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1)
    }
    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
    }
    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    )
  }
  const handleTabChange = (event, newValue) => {
    set_tabValue(newValue)
    const menu = JSON.parse(localStorage.getItem('menu')) || {}
    if (menu?.regi?.tabValue) {
      menu.regi.tabValue = newValue
      localStorage.setItem('menu', JSON.stringify(menu))
    }
  }

  const loadSelStudentList = async (lectureId) => {
    const url = `/regi/sel/student`
    const action = getAction(url, { lectureId: lectureId })
    const resp = await WebService.get(action)
    set_selStudentList([])
    if (resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      set_selStudentList(records)
      openSnackbar('선밞/마감하였습니다.')
    }
  }
  const genAttdnc = async (lectureId) => {
    const url = `/attdnc/${lectureId}`
    const action = getAction(url, {})
    const resp = await WebService.post(action)
    if (resp.repCode === 'ack') {
      openSnackbar('출석부를 생성하였습니다.')
    } else {
      openSnackbar(resp.repMessage)
    }
  }
  const onCloseBill = async (lectureId) => {
    const url = `/lecture/bill/quit/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('처리되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
  }

  const onResetRegis = async (smstId) => {
    const url = `/regi/reset/${schola.id}/${smstId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('처리되었습니다.', () => {
        onLoad()
      })
    } else {
      alert(resp.repMessage)
    }
  }
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }))

  useEffect(() => {
    const menu = JSON.parse(localStorage.getItem('menu')) || {}

    if (!menu.regi) {
      menu.regi = {}
    }

    if (menu.regi.tabValue === undefined) {
      console.log('regitabVaue undefined....')
      menu.regi.tabValue = '1'
      localStorage.setItem('menu', JSON.stringify(menu))
    }

    handleTabChange(null, menu.regi.tabValue)
    if (curLocationRef.current.key !== location.key) {
      curLocationRef.current = location
      set_pageInfo({ pageNum: 0, pageSize: 10 })
    }
  }, [location])

  useEffect(() => {
    onLoad()
  }, [pageInfo])

  useEffect(() => {
    if (originRef.current) {
      const td = transformData(originRef.current, sortBy, sortDirection)
      set_dataList(td)
    }
    
  }, [counter])

  const dg_title = '수강신청 정보'
  const memo_DgContent = useMemo(() => {
    return <ManagerRegiPart />
  }, [recordRef.current, detailScreen])

  const Body = ({ smstPhase }) => {
    console.log('rendeirng body.....')
    const [anchorEl, setAnchorEl] = useState(null)
    const theme = useTheme()
    const handleMenuClick = (event, row) => {
      event.currentTarget.getBoundingClientRect()
      setAnchorEl(event.currentTarget)
    }
    const handleMenuClose = () => {
      setAnchorEl(null)
    }

    const fetchSmstList = async () => {
      if (tabValue == '-1') {
        return
      }
      const url = `/smst/last/1/${schola.id}`
      openIndicator()
      const resp = await WebService.get(url, {})
      closeIndicator()
      if (resp.repCode !== 'ack') {
        alert(resp.repMessage)
        return
      }
      const repMessage = JSON.parse(resp.repMessage)
      const smstList = JSON.parse(repMessage.records)
      return smstList
    }

    return (
      <div ref={inputRef}>
        {+smstPhase == 0 ? (
          <>
            <Typography color={theme.palette.secondary.main} style={{ marginBottom: 5 }}>
              ※ 학기 준비 중에 기수강자 우선 수강신청이 필요할 경우에 파일로 대리신청할 수 있습니다.
            </Typography>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <Button
                startIcon={<FileUploadOutlinedIcon />}
                variant="outlined"
                color="primary"
                size="small"
                sx={{ mr: 1 }}
                onClick={async () => {
                  const smst = await fetchSmstList()
                  if (smst) {
                    dgRef.current.open()
                  }
                  // uploadHandler[1](true)
                }}
              >
                파일로 우선 신청
              </Button>
              <Button startIcon={<FileDownloadOutlinedIcon />} variant="outlined" color="primary" size="small" sx={{ mr: 1 }} onClick={handleSampleDownload}>
                샘플 파일 다운로드
              </Button>
              <Button
                startIcon={<FileDownloadOutlinedIcon />}
                variant="outlined"
                color="primary"
                size="small"
                sx={{ mr: 1 }}
                onClick={async () => {
                  const smst = await fetchSmstList()
                  if (smst) {
                    dgRef2.current.open()
                  }
                }}
              >
                명단 다운로드
              </Button>
            </div>
          </>
        ) : null}
        {Math.floor(smstPhase) === 1 ? (
          <>
            <Typography color={theme.palette.secondary.main} style={{ marginBottom: 5 }}>
              ※ 상태변경은 학기에서 일괄적으로 처리할 것을 권장합니다(모집 초과 시 선발 및 등록마감 현재 페이지에서만 가능).
            </Typography>
            <Typography color={theme.palette.secondary.main} style={{ marginBottom: 5 }}>
              ※ 모집정원을 초과하여 신청된 강좌의 경우 학생선발을 수동으로 하여야 합니다.
            </Typography>
            <Typography color={theme.palette.secondary.main} style={{ marginBottom: 5 }}>
              ※ 결제버튼은 선발완료 이후 활성화 되며 학생별 요금을 별도로 입력해야 할 경우에만 사용하세요.
            </Typography>
            <Typography color={theme.palette.secondary.main} style={{ marginBottom: 10 }}>
              ※ 자동절차로 진행할 경우 선착순 선발일 경우에는 모집마감 시 선발완료까지 자동으로 처리하고 동영상은 저장하지 않습니다.
            </Typography>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <Button
                startIcon={<FileUploadOutlinedIcon />}
                variant="outlined"
                color="primary"
                size="small"
                sx={{ mr: 1 }}
                onClick={async () => {
                  const smst = await fetchSmstList()
                  if (smst) {
                    dgRef.current.open()
                  }
                  // uploadHandler[1](true)
                }}
              >
                파일로 대리신청
              </Button>
              <Button startIcon={<FileDownloadOutlinedIcon />} variant="outlined" color="primary" size="small" sx={{ mr: 1 }} onClick={handleSampleDownload}>
                샘플 파일 다운로드
              </Button>
              <Button
                startIcon={<FileDownloadOutlinedIcon />}
                variant="outlined"
                color="primary"
                size="small"
                sx={{ mr: 1 }}
                onClick={async () => {
                  const smst = await fetchSmstList()
                  if (smst) {
                    dgRef2.current.open()
                  }
                }}
              >
                명단 다운로드
              </Button>
            </div>
          </>
        ) : null}

        <div style={{ paddingTop: 20 }}>
          <MUITable sx={{ minWidth: 1300 }}>
            <MyTableHead>
              <TableRow>
                {fields.map((col, index) => {
                  if (col.visible) {
                    return (
                      <TableCell key={index} size="small">
                        {col.sortable ? (
                          <TableSortLabel
                            active={sortBy === col.field}
                            // 현재 정렬 상태를 그대로 보여줘야 화살표 방향이 상식적으로 움직임?
                            direction={sortDirection}
                            onClick={() => handleSort(col.field)}
                          >
                            {col.placeholder}
                          </TableSortLabel>
                        ) : (
                          <>{col.placeholder}</>
                        )}

                        {col.canSrch ? (
                          <Fragment>
                            <TextField
                              label=""
                              variant="outlined"
                              size="small"
                              inputProps={{
                                style: {
                                  fontSize: '0.875em',
                                  padding: 5,
                                  backgroundColor: '#fff',
                                },
                              }}
                              value={terms[col.field]}
                              onChange={(e) => {
                                const newTerms = { ...terms }
                                newTerms[col.field] = e.target.value
                                set_terms(newTerms)
                              }}
                            />
                          </Fragment>
                        ) : (
                          <Fragment></Fragment>
                        )}
                      </TableCell>
                    )
                  }
                })}
                <TableCell size="small" align={'center'}>
                  관리
                </TableCell>
              </TableRow>
            </MyTableHead>
            <TableBody>
              {dataList &&
                Object.keys(dataList).map((groupId, gidx) =>
                  dataList[groupId].findIndex((r) => Math.floor(+r.smstPhase) === +smstPhase) >= 0 ? (
                    <Fragment key={gidx}>
                      <TableRow>
                        <TableCell rowSpan={dataList[groupId].length + 1}>
                          {dataList[groupId].length > 0 ? (
                            <>
                              <Typography variant="body2">{groupId}</Typography>
                              {+smstPhase === 0 ? (
                                <ConfirmDialog
                                  btn={<Button color="error">전체 명단 초기화</Button>}
                                  title={'주의'}
                                  content={'전체 명단을 초기화 하시겠습니까?'}
                                  bc={'error'}
                                  preHandle={async () => {
                                    return true
                                  }}
                                  perform={() => {
                                    onResetRegis(dataList[groupId][0].smstId)
                                  }}
                                />
                              ) : null}
                            </>
                          ) : (
                            <>'데이터 없음'</>
                          )}
                        </TableCell>
                      </TableRow>
                      {dataList[groupId].map((row, rowIdx) => (
                        <TableRow
                          key={rowIdx}
                          onMouseEnter={() => (recordRef.current = row)}
                          style={{
                            cursor: row.drop ? 'not-allowed' : 'default',
                            pointerEvents: row.drop ? 'none' : 'auto', // 이 행의 모든 클릭을 원천 차단
                          }}
                        >
                          {fields.map((col, colIdx) => {
                            if (col.visible && col.field !== 'smstName') {
                              const isAllowedInDrop = col.field === 'title' || col.field === 'weekString'
                              if (row.drop && !isAllowedInDrop) {
                                return <TableCell key={colIdx} size="small" />
                              }
                              return (
                                <TableCell key={colIdx} style={{ whiteSpace: 'pre-line' }}>
                                  <Typography variant="body2" fontWeight={col.field === 'statName' ? 'bold' : 'normal'}>
                                    {row[col.field]}
                                  </Typography>
                                </TableCell>
                              )
                            }
                          })}
                          {/* {fields.map((col, colIdx) => 
                            col.visible && col.field !== 'smstName' ? (
                              <TableCell key={colIdx} style={{ whiteSpace: 'pre-line' }}>
                                <Typography variant="body2" fontWeight={col.field === 'statName' ? 'bold' : 'normal'}>
                                  {row[col.field]}
                                </Typography>
                              </TableCell>
                            ) : null
                          )} */}

                          {row.drop ? (
                            <TableCell size="small" align={'center'} style={{ height: 45 }}/>
                          ) : (
                            <TableCell size="small" align={'center'} style={{ height: 45 }}>
                              {/* <FlatButton disabled={row.statCode === "S004"} variant='outlined' size='small' style={{ marginRight: 5 }} onClick={() => set_openName(true)}> */}

                              <FlatButton variant="outlined" size="small" style={{ marginRight: 5 }} onClick={() => set_openName(true)}>
                                명단
                              </FlatButton>
                              {Math.floor(+row.smstPhase) !== 2 ? (
                                <FlatButton
                                  variant="outlined"
                                  size="small"
                                  style={{ marginRight: 5 }}
                                  onClick={() => {
                                    postHandler[1](true)
                                  }}
                                >
                                  알림
                                </FlatButton>
                              ) : null}
                              {Math.floor(+row.smstPhase) === 0 ? (
                                <FlatButton
                                  disabled={row.statCode === 'S004'}
                                  variant="outlined"
                                  size="small"
                                  style={{ marginRight: 5 }}
                                  onClick={() => {
                                    if (row.sttNum >= row.rcrNum) {
                                      alert('모집인원을 초과하여 우선신청할 수 없습니다.')
                                      return
                                    }
                                    agencyHandler[1](true)
                                  }}
                                >
                                  우선신청
                                </FlatButton>
                              ) : null}
                              {Math.floor(+row.smstPhase) === 1 ? (
                                <>
                                  <FlatButton
                                    disabled={row.statCode === 'S004'}
                                    variant="outlined"
                                    size="small"
                                    style={{ marginRight: 5 }}
                                    onClick={() => {
                                      if (row.sttNum >= row.rcrNum) {
                                        alert('모집인원을 초과하여 대리신청할 수 없습니다.')
                                        return
                                      }
                                      agencyHandler[1](true)
                                    }}
                                  >
                                    대리신청
                                  </FlatButton>

                                  <Badge
                                    sx={{
                                      '& .MuiBadge-badge': {
                                        // backgroundColor: '#ab47bc',
                                        backgroundColor: 'transparent',
                                        // border: '1px dotted #9e9e9e',
                                        color: '#fff',
                                        transform: 'none',
                                        top: '-10px', // nudge upward
                                        right: '-15px',
                                        // right: 0,
                                        // top: 0,
                                        display: 'flex',
                                        justifyContent: 'flex-end', // horizontal alignment
                                        alignItems: 'center',
                                      },
                                    }}
                                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    invisible={row.statCode !== 'S002'}
                                    badgeContent={
                                      row.statCode === 'S002' ? (
                                        <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                                          {row.reqNum > row.rcrNum ? (
                                            <>
                                              <span
                                                style={{
                                                  fontWeight: 'bold',
                                                  fontSize: '0.8em',
                                                  backgroundColor: '#ab47bc',
                                                  marginRight: '2px',
                                                  whiteSpace: 'nowrap',
                                                  padding: '5px',
                                                  borderRadius: '10%',
                                                }}
                                              >
                                                정원초과
                                              </span>
                                              <Tooltip arrow title="모집정원이 초과된 경우 상태변경 > 학생선발해야 다음 상태로 진행가능합니다.">
                                                <InfoIcon sx={{ color: '#ab47bc' }} />
                                              </Tooltip>
                                            </>
                                          ) : (
                                            <Tooltip arrow title="모집마강되어 상태변경 > 학생선발할 수 있습니다.">
                                              <InfoIcon sx={{ color: '#ab47bc' }} />
                                            </Tooltip>
                                          )}
                                        </div>
                                      ) : null
                                    }
                                  >
                                    <FlatButton
                                      disabled={row.statCode === 'S004'}
                                      id={`${rowIdx}`}
                                      variant="outlined"
                                      color="primary"
                                      style={{ marginRight: 5 }}
                                      onClick={(e) => handleMenuClick(e, row)}
                                    >
                                      상태변경
                                      <ArrowDropDownIcon />
                                    </FlatButton>
                                  </Badge>

                                  <FlatButton
                                    style={{ marginRight: 5, marginLeft: 10 }}
                                    disabled={row.statCode === 'S004' || +row.phase < 3}
                                    onClick={() => {
                                      set_openBill(true)
                                    }}
                                  >
                                    결제
                                  </FlatButton>

                                  <FlatButton disabled={!canDownload(row)} style={{ marginRight: 5 }} onClick={() => handleDownload(row)}>
                                    선발영상 다운로드
                                  </FlatButton>

                                  <ConfirmDialog
                                    btn={
                                      <FlatButton disabled={row.phase <= 0 || row.statCode === 'S004'} style={{ marginRight: 5 }} color="error">
                                        복구
                                      </FlatButton>
                                    }
                                    title={'이전 상태로 복구'}
                                    content={'이전상태로 복구하면 현재상태로 되돌아올 수 없습니다. 해당 강좌의 상태를 전으로 복구하시겠습니까?'}
                                    bc={'error'}
                                    perform={() => {
                                      onRecover(row.id)
                                    }}
                                  />

                                  <Badge
                                    sx={{
                                      '& .MuiBadge-badge': {
                                        backgroundColor: 'transparent',
                                        // border: '1px dotted #9e9e9e',
                                        // color: '#fff',
                                      },
                                    }}
                                    invisible={row.statCode === 'S004' || +row.phase < 3}
                                    badgeContent={
                                      <Tooltip arrow title="폐강 처리하려면 폐강버튼이 활성화 될 때 까지 복구 버튼을 클릭해 주세요.">
                                        <InfoIcon sx={{ color: '#9e9e9e' }} />
                                        {/* <InfoIcon sx={{ color: '#FFF', backgroundColor:'#9e9e9e', fontSize:20, borderRadius: '50%', display: 'inline-block', padding:'5px'}}/> */}
                                      </Tooltip>
                                    }
                                  >
                                    <ConfirmDialog
                                      btn={
                                        <FlatButton
                                          disabled={row.statCode === 'S004' || +row.phase >= 3}
                                          color="warning"
                                          size="small"
                                          style={{ marginRight: 10 }}
                                          onClick={() => {}}
                                        >
                                          폐강
                                        </FlatButton>
                                      }
                                      content={'해당 강좌를 폐강합니다. 폐강 이후에는 복구할 수 없습니다.'}
                                      perform={() => onDiscard(row.id)}
                                    />
                                  </Badge>
                                  {/*<FlatButton variant='outlined' color='secondary' size='small' style={{ marginRight: 5 }}*/}
                                  {/*            onClick={() => {*/}
                                  {/*            }}>*/}
                                  {/*  알림전송*/}
                                  {/*</FlatButton>*/}
                                  {/*<FlatButton variant='outlined' color='secondary' size='small' style={{ marginRight: 5 }}*/}
                                  {/*            onClick={() => {*/}
                                  {/*            }}>*/}
                                  {/*  알림내역*/}
                                  {/*</FlatButton>*/}
                                </>
                              ) : null}
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                    </Fragment>
                  ) : null
                )}
            </TableBody>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => handleMenuClose()}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <ConfirmDialog
                  btn={
                    <FlatButton disabled={recordRef.current.statCode === 'S004' || recordRef.current.phase !== 0} variant={'text'}>
                      모집 (재)시작
                    </FlatButton>
                  }
                  content={'해당 강좌 모집을 시작하시겠습니까?'}
                  perform={() => onStartReq(recordRef.current.id)}
                />
                <ConfirmDialog
                  btn={
                    <FlatButton disabled={recordRef.current.statCode !== 'S001' || recordRef.current.phase !== 1} variant={'text'}>
                      모집 중지
                    </FlatButton>
                  }
                  content={'해당 강좌 모집을 중지하시겠습니까?'}
                  perform={() => onPauseReq(recordRef.current.id)}
                />
                <ConfirmDialog
                  btn={
                    <FlatButton size="lg" disabled={recordRef.current.statCode === 'S004' || recordRef.current.phase !== 1} variant={'text'}>
                      모집 마감
                    </FlatButton>
                  }
                  content={'해당 강좌 모집을 마감하시겠습니까?'}
                  perform={() => onQuitReq(recordRef.current.id)}
                />
                <ConfirmDialog
                  btn={
                    <FlatButton
                      size="lg"
                      disabled={recordRef.current.statCode === 'S004' || !['S002', 'S012'].includes(recordRef.current.statCode)}
                      variant={'text'}
                    >
                      추가모집 시작
                    </FlatButton>
                  }
                  bc={'primary'}
                  content={'추가모집을 시작하시겠습니까?'}
                  perform={() => onReopen(recordRef.current.id)}
                />

                <Divider />

                {/* 필수 --> */}
                <FlatButton
                  disabled={recordRef.current.statCode === 'S004' || recordRef.current.phase !== 2}
                  variant={'text'}
                  onClick={() => {
                    if (recordRef.current.reqNum == 0) {
                      alert('해당 강좌의 지원자가 없어 선발을 할 수 없습니다. 대리신청, 추가신청 또는 폐강을 해주세요.')
                      handleMenuClose()
                      return
                    } else {
                      set_openPick(true)
                    }

                    /*
                    if(recordRef.current.reqNum == 0)  {
                      onSaveEmptyPickList()
                      handleMenuClose()
                    }
                    else {
                      set_openPick(true)
                    }
                    */
                  }}
                >
                  학생선발
                </FlatButton>
                <Divider />
                {/* <FlatButton */}
                {/* 	disabled={recordRef.current.statCode === "S004" || recordRef.current.phase !== 3} */}
                {/* 	variant={"text"} */}
                {/* 	onClick={() => { */}
                {/* 		set_openBill(true) */}
                {/* 	}}> */}
                {/* 	결제관리 */}
                {/* </FlatButton> */}
                {/* 필수 <-- */}

                <ConfirmDialog
                  btn={
                    <FlatButton disabled={recordRef.current.statCode === 'S004' || recordRef.current.phase !== 3} variant={'text'}>
                      등록마감
                    </FlatButton>
                  }
                  title={'등록마감'}
                  content={'해당 강좌의 등록을 마감합니다.'}
                  bc={'primary'}
                  perform={() => {
                    onCloseBill(recordRef.current.id)
                  }}
                />
                <Divider />
                <ConfirmDialog
                  btn={
                    <FlatButton disabled={recordRef.current.statCode === 'S004' || recordRef.current.phase !== 4} variant={'text'}>
                      출석부생성
                    </FlatButton>
                  }
                  title={'출석부 생성'}
                  content={'해당 강좌의 출석부를 생성하고, 해당 강좌의 강의 준비가 완료됩니다.'}
                  bc={'primary'}
                  perform={() => {
                    onAttdnc(recordRef.current.id)
                  }}
                />
                <ConfirmDialog
                  btn={
                    <FlatButton disabled={recordRef.current.statCode === 'S004' || recordRef.current.phase !== 5} variant={'text'}>
                      개강
                    </FlatButton>
                  }
                  title={'개강'}
                  content={'해당 강좌를 개강하시겠습니까?'}
                  bc={'primary'}
                  perform={() => {
                    onOpenLecture(recordRef.current.id)
                  }}
                />
                <ConfirmDialog
                  btn={
                    <FlatButton disabled={recordRef.current.statCode === 'S004' || recordRef.current.phase !== 6} variant={'text'}>
                      종강
                    </FlatButton>
                  }
                  title={'개강'}
                  content={'해당 강좌를 종강하시겠습니까?'}
                  bc={'primary'}
                  perform={() => {
                    onCloseLecture(recordRef.current.id)
                  }}
                />
                <ConfirmDialog
                  btn={
                    <FlatButton variant={'text'} color={'error'}>
                      강좌 데이터 리셋
                    </FlatButton>
                  }
                  title={'개강'}
                  content={'수강(신청) 관련 모든 데이터가 삭제 되어 복구할 수 없으며, 강좌는 준비 상태로 됩니다. 실행하시겠습니까? '}
                  bc={'error'}
                  perform={() => {
                    onResetLecture(recordRef.current.id)
                  }}
                />
              </Box>
            </Menu>
          </MUITable>
        </div>
      </div>
    )
  }
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <div style={{ paddingRight: 10 }}>
          <h1>수강신청 관리 </h1>
        </div>
      </div>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', position: 'sticky', top: 0, backgroundColor: '#fff' }}>
            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
              <Tab label="학기준비(우선신청)" value="0" />
              <Tab label="현재(활성)" value="1" />
              <Tab label="이전내역" value="2" />
            </TabList>
          </Box>
          <TabPanel value="0" sx={{ minHeight: '60vh' }}>
            <Body smstPhase="0" />
          </TabPanel>
          <TabPanel value="1" sx={{ minHeight: '60vh' }}>
            <Body smstPhase="1" />
          </TabPanel>
          <TabPanel value="2" sx={{ minHeight: '60vh' }}>
            <Body smstPhase="2" />
          </TabPanel>
        </TabContext>
      </Box>
      <div>
        {agencyHandler[0] ? <ManagerRegiPartAgency record={recordRef.current} dialogHandler={agencyHandler} callback={onLoad} /> : null}
        {openName ? <ManagerRegiPartName record={recordRef.current} open={openName} onClose={() => set_openName(false)} reload={onLoad} /> : null}
        {openPick ? <ManagerRegiPartPick record={recordRef.current} open={openPick} onClose={() => set_openPick(false)} reload={onLoad} /> : null}
        {openBill ? <ManagerRegiPartBill record={recordRef.current} open={openBill} onClose={() => set_openBill(false)} reload={onLoad} /> : null}
        {<ManagerRegiPartUpload ref={dgRef} callback={onLoad} smstPhase={+tabValue} />}
        {<ManagerRegiPartDownload ref={dgRef2} callback={null} smstPhase={+tabValue} />}
        {postHandler[0] ? <ManagerMessagePartPost dialogHandler={postHandler} topic="TP06" tid={recordRef.current.id} msgType="push" /> : null}
        {renderIndicator()}
        {renderAlert()}
      </div>
    </>
  )
}
export default ManagerRegiPage
